var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gallery.length > 0)?_c('section',[_c('div',{staticClass:"apartment-gallery"},[_c('gallery',{attrs:{"items":_vm.gallery,"sizes":'400px',"itemsPerView":[1,2,3,3]}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }